import Cookie from "js-cookie";



const URL = 'https://apigateway-test.nordciti.ru/v1/GLK/'


export const getTrainersList = async (date) => {
    const response = await fetch(URL + `getTrainerList?date=${date}`, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
    const data = await response.json()
    return data
}

export const getTimetable = async (trainerId, date) => {
    const response = await fetch(URL + `getTimetable?trainerId=${trainerId}&date=${date}`, {
        headers: {
            'Content-Type': 'application/json'
        }

    })
    const data = await response.json()
    return data
}

export const getProfileInfo = async () => {
    const response = await fetch('https://apigateway.nordciti.ru/test/auth/getClientInfo', {
        credentials: "include",
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Cookie.get('tokenTest')}`
        }
    })
    const data = await response.json()
    return data
}

export const createOrder = async (order) => {
    const response = await fetch(URL + 'createOrder', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Cookie.get('tokenTest')}`
        },
        body: JSON.stringify(order)
    })
    const data = await response.json()
    return data
}

export const getLesson = async (clientId, lessonId) => {
    const response = await fetch(URL + `getTimetableForCurrentClient?clientId=${clientId}&lessonId=${lessonId}`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Cookie.get('tokenTest')}`
        }
    })
    const data = await response.json()
    return data
}

export const cancelOrder = async (clientId, lessonId) => {
    const response = await fetch(URL + `cancelRegistration`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Cookie.get('tokenTest')}`
        },
        body: JSON.stringify({
            clientId: clientId,
            lessonId: lessonId
        })
    })
    const data = await response.json()
    return data
}

export const cancelOrderForm = async (obj) => {
    const response = await fetch(URL + `registerRefund`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Cookie.get('tokenTest')}`
        },
        body: JSON.stringify(obj)
    })
    const data = await response.json()
    return data
}

export const getTrainerAvailableDates = async (trainerId) => {
    const response = await fetch(URL + `GetTrainerAvailableDatesAsync?trainerId=${trainerId}`, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
    const data = await response.json()
    return data
}

export const checkAvailability = async (trainerId, dateBeg) => {
    const response = await fetch(URL + `CheckAvailability?trainerId=${trainerId}&dateBeg=${dateBeg}`, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
    const data = await response.json()
    return data
}

export const getServiceStatus = async () => {
    const response = await fetch(URL + 'getServiceStatus', {
        headers: {
            'Content-Type': 'application/json'
        }
    })
    const data = await response.json()
    return data
}